import React, {useEffect, useState} from "react";
import {QuestionOptions} from "./QuestionOptions";
import {TextContent} from "../course/TextContent";

export function Question(props) {

    const [question, setQuestion] = useState(null);

    useEffect(() => {
        setQuestion(props.question)
    }, [props.question])


    if(question != null) {
        return (

            <div className={"d-flex justify-content-center align-content-center m-0 w-100"} style={{minWidth:"100%"}}>
                <div className={"row rounded"} style={{width:"100%"}}>

                    <div className={"col text-start p-4 d-flex flex-column "}>

                        <TextContent className={"mt-3  pb-3"} value={props.question.text} level={3}/>

                        <QuestionOptions options={question.options} disabled={props.disabled} displayAnswers={props.displayAnswers} nextQuestionCallback={props.nextQuestionCallback} multipleChoice={props.question.multipleChoice} selectOptionCallback={props.selectOptionCallback}/>

                    </div>

                </div>
            </div>

        );
    }


}